export const homePageEvent = () => {
  window.fbq('track', 'home-page')
}